/**
 * Shared QueryClient Configuration
 *
 * Disables refetchOnWindowFocus to prevent redundant API calls
 * (e.g. /users/me/) every time the user switches tabs.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});